import get from 'lodash/get.js';
export function getProgress(data) {
    if (typeof data === 'number')
        return data;
    if (data == null || typeof data !== 'object' || !('progress' in data))
        return 0;
    return typeof data.progress === 'number'
        ? data.progress
        : // biome-ignore lint/style/noNonNullAssertion: <explanation>
            get(data, 'progress.progress');
}
//# sourceMappingURL=progress.js.map